<template>
    <div>
        <label class="text-sm font-medium text-gray-700 flex justify-between items-center" style="width:100%" for="password">
            Password
            <div class="flex items-center space-x-1 cursor-pointer" @click.prevent="toggleVisibility()">
                <i :class="'mdi ' + passwordToggleIcon"></i>
                <span>{{ passwordToggleLabel }}</span>
            </div>
        </label>
        <input id="password"
               :type="passwordFieldType"
               class="form-control"
               v-model="password"
               :class="inputClass"
               name="password"
               required>
    </div>
</template>

<script>
export default {

    props: ["inputClass"],

    data () {
        return {
            passwordFieldType: "password",
            password: ""
        };
    },

    computed: {
        passwordToggleIcon () {
            return this.passwordFieldType === "password" ? "mdi-eye-outline" : "mdi-eye-off-outline";
        },

        passwordToggleLabel () {
            return this.passwordFieldType === "password" ? "Show" : "Hide";
        }
    },

    methods: {
        toggleVisibility () {
            this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
            document.getElementById("password").focus();
        }
    }

};
</script>